<template>
  <Modal ref="modal" title="Informações da fatura">
    <div v-if="loading" class="d-flex justify-content-center">
      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
      </component>
    </div>

    <div v-else class="info-container">
      <div class="info-row">
        <Input legend="Status" :modelValue="fatura.status" :readonly="true" />
        <Input legend="Processo" :modelValue="fatura.tipo" :readonly="true" />
        <Input legend="Cód. Processo" :modelValue="fatura.codigo_processo" :readonly="true" />
      </div>
      <div class="info-row">
        <Input legend="Nome do aluno" :modelValue="fatura.nome" :readonly="true" />
        <Input legend="CPF do aluno" :modelValue="utils.formatarCPF(fatura.cpf)" :readonly="true" />
        <Input legend="Data do processo" :modelValue="utils.formatOnlyDate(fatura.created_at.split(' ')[0])" :readonly="true" />
      </div>
      <div class="info-row">
        <Input legend="Código de barras" :modelValue="fatura.linhaDigitavel || '-'" :readonly="true" />
      </div>
      <div class="info-row">
        <Input legend="Valor original" :modelValue="utils.formatarValor(fatura.valor_servico) || '-'" :readonly="true" />
        <Input legend="Valor do desconto" :modelValue="utils.formatarValor(fatura.discount_value) || '-'" :readonly="true" />
        <Input legend="Valor do juros" :modelValue="utils.formatarValor(fatura.valor_juros) || '-'" :readonly="true" />
        <Input legend="Valor do multa" :modelValue="utils.formatarValor(fatura.valor_multa) || '-'" :readonly="true" />
        <Input legend="Valor a pagar" :modelValue="utils.formatarValor(fatura.valor) || '-'" :readonly="true" />
      </div>
    </div>
  </Modal>
</template>

<script>
import * as spinners from 'epic-spinners'
import Modal from '../core/Modal.vue'
import Input from '../core/Input'
import utils from '../../services/utils'

export default {
  name: 'InfoModal',
  components: {
    ...spinners,
    Modal,
    Input,
  },
  data() {
    return {
      utils: utils,
      fatura: null,
      loading: true,
    }
  },
  methods: {
    open(fatura) {
      this.$refs.modal.open()
      this.fatura = fatura
      this.loading = false
    },
    close() {
      this.$refs.modal.close()
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.info-container {
  width: 60vw;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .info-row {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    >div {
      flex: 1;
    }
  }
}
</style>